import { render } from "./ShortcodeInput.vue?vue&type=template&id=72e199f2"
import script from "./ShortcodeInput.vue?vue&type=script&lang=js"
export * from "./ShortcodeInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__